<script>
  import { onDestroy, createEventDispatcher } from 'svelte';

  import Profile from '@utils/profile';
  import GroupAjax from '@ajax/group';
  import GroupCollectionAjax from '@ajax/group_collection';
  import UserAjax from '@ajax/user';

  import { getProfileStore } from '@stores/profile';

  import AddGroupModal from '@app-components/modal/AddGroupModal.svelte';
  import AddEditCollectionModal from '@app-components/modal/AddEditCollectionModal.svelte';
  import { getCurrentUserStore } from '@stores/current_user';

  export let mobile = false;

  const dispatch = createEventDispatcher();

  let groupsStore = getProfileStore('groupsStore');
  let groupCollectionStore = getProfileStore('groupCollectionStore');
  let groupCollectionSortOrderStore = getProfileStore('groupCollectionSortOrderStore');

  let user = getCurrentUserStore('default');
  let authUnsub = user.subscribe((x) => (user = x));

  let showAddDropdown = false;
  let showAddEditCollectionModal = false;

  let showAddGroup = false;

  let groups = groupsStore;
  let groupCollections = groupCollectionStore;

  let unsubGroups = groupsStore.subscribe((x) => (groups = x));
  let unsubGroupCollections = groupCollectionStore.subscribe((x) => (groupCollections = x));

  $: showCollectionButton = groups.length > 5 || groupCollections.length > 1;

  let toggleDropdown = () => {
    if (showCollectionButton) {
      showAddDropdown = !showAddDropdown;
    } else {
      addGroup();
    }
  };

  let createGroup = async function (data) {
    try {
      let group = await GroupAjax.create(data);
      dispatch('added-group', { group: group });
      showAddDropdown = false;
    } catch {}
  };

  let addGroup = async function () {
    if (mobile) {
      showAddGroup = true;
    } else {
      createGroup({ name: 'My new list' });
    }
  };

  let addCollectionToOrm = function (collection) {
    let ids = [...Profile.collectionSortOrderByPageIds(), collection.id];
    groupCollectionSortOrderStore.set(ids);
    groupCollectionStore.add(collection);

    UserAjax.update(user, {
      group_collection_sort_order: ids,
    });
  };

  let addCollection = async function () {
    if (mobile) {
      showAddEditCollectionModal = true;
    } else {
      try {
        let resp = await GroupCollectionAjax.create({ name: 'New collection' });
        addCollectionToOrm(resp);
        dispatch('added-collection', { collection: resp });
      } catch {}
    }

    showAddDropdown = false;
  };

  onDestroy(() => {
    authUnsub();
    unsubGroups();
    unsubGroupCollections();
  });
</script>

<style style="text/scss" lang="scss">
  .profile-add-actions-dropdown {
    height: 190px;
    width: 356px;
    background: white;
    position: absolute;
    z-index: 1;
    border-radius: 30px;
    right: 0;
    margin-top: 15px;
    box-shadow: 0 12px 64px -20px #ccc;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 16px;
    padding: 20px;
  }

  .add-collection-btn {
    cursor: pointer;
    margin-top: 5px;
  }

  .action-btn {
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    &:hover {
      opacity: 0.75;
    }
  }

  .mobile {
    .profile-add-actions-dropdown {
      position: fixed;
      left: 20px;
      right: 20px;
      margin-left: auto;
      margin-right: auto;
      bottom: 80px;
      width: unset;
    }
  }
</style>

{#if showAddGroup}
  <AddGroupModal
    mobile={mobile}
    bind:showModal={showAddGroup}
    on:create-group={(e) => {
      createGroup(e.detail);
    }} />
{/if}

{#if showAddEditCollectionModal}
  <AddEditCollectionModal
    mobile={mobile}
    bind:showModal={showAddEditCollectionModal}
    on:added-collection={(e) => {
      dispatch('added-collection', e.detail);
    }}
    on:updated-collection={(e) => {
      dispatch('updated-collection', e.detail);
    }} />
{/if}

<div style="position: relative; display: inline-block;" class:mobile={mobile}>
  <div class="add-collection-btn" on:click|preventDefault|stopPropagation={() => toggleDropdown()}>
    <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12
              0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#A893F9" />
      <path d="M16 12H8" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M12 8V16" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </div>

  {#if showAddDropdown}
    <div class="backdrop" style="z-index: 1" on:click|preventDefault|stopPropagation={toggleDropdown} />

    <div class="profile-add-actions-dropdown">
      <div class="action-btn" style="background: #EEE9FE;" on:click|preventDefault|stopPropagation={addGroup}>
        <img src="/images/profile-add-content-dropdown/new-list.svg" style="height: 46px; margin-bottom: 23px;" />
        <div>New List</div>
      </div>
      <div class="action-btn" style="background: #FFF6EC;" on:click|preventDefault|stopPropagation={addCollection}>
        <img src="/images/profile-add-content-dropdown/new-collection.svg" style="height: 46px; margin-bottom: 22px;" />
        <div>New Collection</div>
      </div>
    </div>
  {/if}
</div>
